import React, { useState } from 'react';
import { toast } from 'sonner';
import { LayoutDashboardIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { carriedAdjustments, troyBaseBands, monthlyBonusBands, statementLoans, statementMeta, statementOptions } from '../data/statement';
import { useInactivityLock } from '../hooks/useInactivityLock';
import { Badge } from '../components/sf/Badge';
import { Button } from '../components/sf/Button';
import { OpenQuestionBadge } from '../components/sf/OpenQuestionBadge';
import { RecordHeader } from '../components/sf/RecordHeader';
import { SelectField } from '../components/sf/SelectField';
import { StatusBadge } from '../components/sf/StatusBadge';
import { CarriedAdjustmentsCard } from '../components/statement/CarriedAdjustmentsCard';
import { ManagerScopeView } from '../components/statement/ManagerScopeView';
import { PinLockScreen } from '../components/statement/PinLockScreen';
import { StatementLoansTable } from '../components/statement/StatementLoansTable';
import { StatementSummary } from '../components/statement/StatementSummary';
import { TierProgress } from '../components/statement/TierProgress';
const INACTIVITY_MS = 10 * 60 * 1000;
export function LoStatement() {
  const [viewAs, setViewAs] = useState('self');
  const {
    isLocked,
    lock,
    unlock
  } = useInactivityLock(INACTIVITY_MS);
  const isManager = viewAs === 'manager-az';
  const handlePeriodChange = (value: string) => {
    if (value === statementMeta.period) return;
    toast(`Period: ${value}`, {
      description: 'This prototype shows October 2026 only.'
    });
  };
  return <div className="space-y-3" data-id="element-1198" data-mp="efkxk3wn4cgq">
      <RecordHeader objectLabel="Commission Dashboard" title={isManager ? 'Arizona team — October 2026' : `${statementMeta.loanOfficer} — ${statementMeta.period}`} icon={LayoutDashboardIcon} iconBg="#7F8DE1" titleAddon={<>
            <StatusBadge status="Open" data-id="element-1200" data-mp="9g80yrfyvr0y" />
            {isLocked ? <Badge tone="neutral" icon={<LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-1202" data-mp="2b5du7ceu2iyk" />} data-id="element-1201" data-mp="2b544zr1m4ftx">
                PIN required
              </Badge> : <Badge tone="successLight" icon={<ShieldCheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-1204" data-mp="22ctsg338vy9i" />} data-id="element-1203" data-mp="26d49casks935">
                PIN verified
              </Badge>}
          </>} actions={!isLocked && <Button icon={<LockIcon data-id="element-1206" data-mp="2u4i0idezpymj" />} onClick={lock} data-id="element-1205" data-mp="2u3q5b3pb22ws">
              Lock now
            </Button>} toolbar={<div className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-1207" data-mp="2q3fxrmlv74ft">
            <SelectField id="dashboard-view-as" label="View as" value={viewAs} options={statementOptions.viewAs} onChange={setViewAs} data-id="element-1208" data-mp="2l2sa9awuh5qc" />
            <SelectField id="dashboard-period" label="Period" value={statementMeta.period} options={statementOptions.periods.map(period => ({
        value: period,
        label: period
      }))} onChange={handlePeriodChange} data-id="element-1209" data-mp="2g3p4tpcycxhu" />
            <p className="ml-auto flex items-center gap-1.5 text-xs text-sf-weak" data-id="element-1210" data-mp="umfzxsy2h61o">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1211" data-mp="zjeqk1iiuuv4" />
              PIN-protected · auto-lock timeout to be confirmed (open question)
              <OpenQuestionBadge data-id="element-1212" data-mp="14h81f7ursd1q" />
            </p>
          </div>} data-id="element-1199" data-mp="egcgae552fpl" />

      {isLocked ? <PinLockScreen onUnlock={unlock} data-id="element-1213" data-mp="19bucf9wxw3la" /> : isManager ? <ManagerScopeView data-id="element-1214" data-mp="1db34macbzteq" /> : <>
          <StatementSummary loans={statementLoans} adjustments={carriedAdjustments} units={statementMeta.units} volume={statementMeta.volume} adjustedVolume={statementMeta.adjustedVolume} period={statementMeta.period} data-id="element-1215" data-mp="1iafruw7472hu" />
          <TierProgress branch={statementMeta.branch} volume={statementMeta.volume} unitsThisMonth={statementMeta.units} baseBands={troyBaseBands} bonusBands={monthlyBonusBands} data-id="element-1216" data-mp="3p1f79mxj0cj0" />
          <StatementLoansTable loans={statementLoans} data-id="element-1217" data-mp="1oaerwtkn5a9t" />
          <CarriedAdjustmentsCard adjustments={carriedAdjustments} data-id="element-1218" data-mp="1jdekae857zgl" />
        </>}
    </div>;
}